// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "-legacy." + {"56":"deff8c85","176":"cab2fe7e","466":"184024af"}[chunkId] + ".js";
};